import React, { useState } from 'react';
import i18n from '@/utils/i18n';
import { ButtonWithConfirmation } from '../../components/ButtonWithConfirmation';
import { useMutation } from '@apollo/client';
import {
  enableStoreMutation,
  removeStoreMutation,
} from '../../graphql/mutations';
import { Input, Label } from 'reactstrap';

type RemoveStoreProps = {
  storeName: string;
  externalStoreId: string | null;
  contractEndDate?: string | null;
  removalReason?: string | null;
};

export const RemoveStore = function ({
  storeName,
  externalStoreId,
  contractEndDate,
  removalReason: existingRemovalReason,
}: RemoveStoreProps) {
  const [removeStore, { loading: removingStore }] =
    useMutation(removeStoreMutation);
  const [removalReason, setRemovalReason] = useState('');

  const isContractExpired =
    !!contractEndDate && new Date(contractEndDate) < new Date();

  const onRemoveStoreClick = () => {
    if (!externalStoreId) {
      alert('Error: externalPickpackId is not set');
      return;
    }
    if (!removalReason.trim()) {
      alert(i18n.t('Merchants:pleaseEnterRemovalReason'));
      return;
    }
    removeStore({
      variables: {
        id: externalStoreId,
        removal_reason: removalReason.trim(),
      },
    }).then(() => {
      // too lazy
      window.location.reload();
    });
  };

  return (
    <div>
      {existingRemovalReason && (
        <p className="text-muted small mb-2">
          <strong>{i18n.t('Merchants:removalReasonLabel')}</strong>{' '}
          {existingRemovalReason}
        </p>
      )}
      <div className="mb-2">
        <Label for="removal-reason">{i18n.t('Merchants:removalReason')}</Label>
        <Input
          id="removal-reason"
          type="textarea"
          value={removalReason}
          onChange={(e) => setRemovalReason(e.target.value)}
          placeholder={i18n.t('Merchants:removalReasonPlaceholder')}
          rows={2}
        />
      </div>
      <ButtonWithConfirmation
        color="danger"
        onConfirmed={() => onRemoveStoreClick()}
        confirmationText={i18n.t('Merchants:confirmDisableStore', {
          storeName,
        })}
        disabled={removingStore || !isContractExpired || !removalReason.trim()}
      >
        {removingStore
          ? i18n.t('Merchants:disablingStore')
          : i18n.t('Merchants:disableStore')}
      </ButtonWithConfirmation>
      {!isContractExpired && (
        <p className="text-muted small mb-0 mt-2">
          {i18n.t('Merchants:contractEndDateNotPassed')}
          {!contractEndDate && ' ' + i18n.t('Merchants:noContractEndDateSet')}
        </p>
      )}
    </div>
  );
};

export const EnableStore = function ({
  storeName,
  externalStoreId,
  removalReason,
}: RemoveStoreProps) {
  const [enableStore, { loading: enablingStore }] =
    useMutation(enableStoreMutation);

  const onEnableStoreClick = () => {
    if (!externalStoreId) {
      alert('Error: externalPickpackId is not set');
      return;
    }
    enableStore({
      variables: {
        id: externalStoreId,
      },
    }).then(() => {
      // too lazy
      window.location.reload();
    });
  };

  return (
    <div>
      {removalReason && (
        <p className="text-muted small mb-2">
          <strong>{i18n.t('Merchants:removalReasonLabel')}</strong>{' '}
          {removalReason}
        </p>
      )}
      <ButtonWithConfirmation
        onConfirmed={() => onEnableStoreClick()}
        confirmationText={i18n.t('Merchants:confirmEnableStore', { storeName })}
        disabled={enablingStore}
      >
        {enablingStore
          ? i18n.t('Merchants:enablingStore')
          : i18n.t('Merchants:enableStore')}
      </ButtonWithConfirmation>
    </div>
  );
};
